import { DetailedHTMLProps, InputHTMLAttributes, forwardRef } from 'react';

import { IconSystem } from '@/icons/IconSystem';

import styles from './SearchInput.module.scss';

type Props = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & { onClear?: () => void };

export const SearchInput = forwardRef<HTMLInputElement, Props>(({ onClear, ...inputProps }, ref) => {
	return (
		<div className={styles.wrapper}>
			<input
				className={`${styles.input} body5`}
				aria-label="Suchbegriff eingeben"
				placeholder="Suchbegriff eingeben"
				ref={ref}
				type="text"
				{...inputProps}
			/>

			<button className={styles.close} onClick={onClear}>
				<IconSystem icon="close" variant="filled" title="Suche zurücksetzen" />
			</button>
		</div>
	);
});
